import { component } from 'riot'
import {resolveRoutes} from './helpers/routes'

// if you need add regex to catch string query
// DON'T add / at the end
const routes = [
    {
        path: '/',
        component: 'pg-home'
    },
    {
        path: '/politicas-de-privacidade',
        component: 'pg-privacy-policy'
    }
]

export default resolveRoutes(routes)
